import type { InterventionAssignButtonProps } from "./intervention-assign-button.type";

import { ModelAssignButton } from "@/modules/model-assign";

import { InterventionAssignForm } from "../intervention-assign-form";

export const InterventionAssignButton = ({
  intervention,
  options,
  ...buttonProps
}: InterventionAssignButtonProps) => {
  return (
    <ModelAssignButton
      item={intervention}
      form={
        <InterventionAssignForm intervention={intervention} options={options} />
      }
      {...buttonProps}
    />
  );
};
